/*
Microphone created using standard javascript library
https://www.npmjs.com/package/react-speech-recognition
Now available only on Chrome
We will eventually move towards Google speechToText
*/
import React, { Component } from 'react';
import { 
    Button,
    Spinner } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faMicrophone } from '@fortawesome/free-solid-svg-icons'
import PropTypes from 'prop-types';

library.add(faMicrophone)

export default class Mic extends Component {

  state = {
      micPressed: false,
      recognition: null
  }

  componentDidMount(){
    var rec = new (window.SpeechRecognition || window.webkitSpeechRecognition || window.mozSpeechRecognition || window.msSpeechRecognition)();
    rec.continuous = false;
    rec.autoStart = false;
    rec.lang = 'en';
    rec.onresult = (e) => {
      var current = e.resultIndex;      
      console.log("RESULT "+e.results[current][0].transcript);    
      this.props.setText(e.results[current][0].transcript);
      this.setState({
        micPressed: false
      });
    }
    rec.onend = (e) => {   
      //use onend if we want continuous speech  
      console.log("onend");
      this.setState({
        micPressed: false
      });
    }
    this.setState({
      recognition: rec
    });
  }

  micClick = (e) => {
    if(!this.state.micPressed){
        //registra
        console.log("START...");
        this.props.setText("");
        this.state.recognition.start();
    }else{
        //chiudi registrazione
        console.log("STOP...");
        this.state.recognition.stop();
    }
    this.setState({
      micPressed: !this.state.micPressed
    });
  }

  render() {

    var micIcon;
    if (this.state.micPressed) {
      micIcon = <Spinner style={iconSize} type="grow" color="light" />;
    } else {
      micIcon = <FontAwesomeIcon style={iconSize} icon="microphone" />;
    }

    return (
        <React.Fragment>
            <Button onClick={this.micClick} color="primary">{micIcon}</Button>
        </React.Fragment>
    );
  }
}

const iconSize = {
    width: '1rem', 
    height: '1rem'
}

Mic.propTypes = {
    setText: PropTypes.func.isRequired, //function that allow to return the speech
}
